import dayjs from 'dayjs'
import { atom } from 'jotai'

import { formatToDate } from '../utils/TimeUtility'

// ============================================================================
// GROUP SESSION（团体课程）相关 Atoms
// ============================================================================

// 团体课程表单默认值
const GROUP_SESSION_DEFAULT_FORM = {
  title: '',
  description: '',
  sport: '',
  skiResort: '',
  useAbsolute: true,
  date: formatToDate(dayjs()),
  times: [],
  price: '',
  participantIds: [],
  minParticipants: 3,
  maxParticipants: 8,
  registrationDeadlineHours: 24,
  cancellationDeadlineHours: 12,
  pictures: [],
}

const createGroupSessionCreateState = function () {
  // 团体课程创建表单数据
  const groupSessionCreateFormAtom = atom(GROUP_SESSION_DEFAULT_FORM)

  // 团体课程创建表单验证错误
  const groupSessionCreateErrorAtom = atom({})

  // 团体课程创建提交状态
  const groupSessionCreateSubmitAtom = atom(false)

  // 团体课程创建表单重置键（用于强制重新渲染表单）
  const groupSessionCreateFormKeyAtom = atom(0)

  // 重置所有团体课程创建相关 atoms 到默认值
  const groupSessionCreateResetAtom = atom(null, (get, set) => {
    console.log('resetting group session create atoms')
    set(groupSessionCreateFormAtom, GROUP_SESSION_DEFAULT_FORM)
    set(groupSessionCreateErrorAtom, {})
    set(groupSessionCreateSubmitAtom, false)
    const prevKey = get(groupSessionCreateFormKeyAtom)
    set(groupSessionCreateFormKeyAtom, prevKey + 1)
  })

  // 团体课程创建统一导出对象
  const groupSessionCreateAtom = {
    form: groupSessionCreateFormAtom,
    formErrors: groupSessionCreateErrorAtom,
    submit: groupSessionCreateSubmitAtom,
    formKey: groupSessionCreateFormKeyAtom,
    reset: groupSessionCreateResetAtom,
  }
  return groupSessionCreateAtom
}

const groupSessionCreateStateAtom = createGroupSessionCreateState()

export default groupSessionCreateStateAtom
export const groupSessionCreateFormAtom = groupSessionCreateStateAtom.form
export const groupSessionCreateErrorAtom = groupSessionCreateStateAtom.formErrors
export const groupSessionCreateSubmitAtom = groupSessionCreateStateAtom.submit
export const groupSessionCreateFormKeyAtom = groupSessionCreateStateAtom.formKey
export const groupSessionCreateResetAtom = groupSessionCreateStateAtom.reset
